// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const green = "PasswordField__green__Qmcmo";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const messageWrapper = "PasswordField__messageWrapper__TNAgz TextField__errorsWrapper__mLqD9 font-faces__sansRegular__c8KXl font-faces__sans__uCf65 TextField__singleError__TVfh8";
export const red = "PasswordField__red__F9FkV";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const yellow = "PasswordField__yellow__3r9-b";